module.exports = __webpack_public_path__ + "static/img/104143.d7ec1aaa.png";